<template>
    <el-dialog
        style="padding: 0 20px 20px 20px !important;"
        width="80%"
        :title="title"
        :visible.sync="visible"
        :before-close="handleClose"
    >
        <!--        <el-button size="mini" @click="addRecords" style="margin:20px">添加记录</el-button>-->
        <el-button type="primary" @click="onSubmit" size="small" style="margin-bottom: 10px">刷新</el-button>

        <el-table
            :data="list"
            size="mini"
            ref="multipleTable"
            class="table_content mini_div"
            border
            v-loading="loading"
        >
            <el-table-column label="ID" width="80" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.id }}</div>
                </template>
            </el-table-column>

            <el-table-column label="国家" width="80" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.state }}</div>
                </template>
            </el-table-column>

            <el-table-column label="Asin" width="130" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.asin }}</div>
                </template>
            </el-table-column>

            <el-table-column label="广告组合名称" min-width="80" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.ad_portfolio_name }}</div>
                </template>
            </el-table-column>

            <el-table-column label="广告组解析类型" min-width="80" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.type }}</div>
                </template>
            </el-table-column>

            <el-table-column label="记录最早时间" min-width="80" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.excel_begin_date || '-' }}</div>
                </template>
            </el-table-column>

            <el-table-column label="记录最晚时间" min-width="80" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.excel_end_date || '-' }}</div>
                </template>
            </el-table-column>


            <el-table-column label="创建时间" width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.add_time || '-' }}</div>
                </template>
            </el-table-column>

            <el-table-column label="解析时间" width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.parsing_time || '-' }}</div>
                </template>
            </el-table-column>

            <el-table-column label="操作" min-width="210" align="center">
                <template slot-scope="scope">
                    <!--                    <el-button v-if="scope.row.status === 0" style="margin: 5px 0 5px 10px" type="success" size="mini"-->
                    <!--                               @click="startDecode(scope.row)">开始解析-->
                    <!--                    </el-button>-->
                    <el-button v-if="scope.row.status === 0" style="margin: 5px 0 5px 10px" type="info" size="mini">未解析
                    </el-button>
                    <el-button v-if="scope.row.status === 1" style="margin: 5px 0 5px 10px" type="success" size="mini">
                        解析中
                    </el-button>
                    <el-button v-if="scope.row.status === 2" style="margin: 5px 0 5px 10px" type="success" size="mini">
                        解析完成
                    </el-button>
                    <el-button style="margin: 5px 0 5px 10px" type="success" size="mini" @click="downLoad(scope.row)"
                               v-if="scope.row.status == '2'">下载
                    </el-button>
                    <el-button v-if="scope.row.status === -1" style="margin: 5px 0 5px 10px" type="danger" size="mini">
                        解析失败
                    </el-button>
                    <el-button type="danger" @click="showErrorInfo(scope.row)" v-if="scope.row.status == '-1'"
                               size="mini" style="margin: 5px 0 5px 10px">查看失败原因
                    </el-button>
                    <!-- <el-button
                        v-if="scope.row.status !== 0 && scope.row.status !== 1"
                        style="margin: 5px 0 5px 10px"
                        type="success"
                        size="mini"
                        @click="startDecode(scope.row, 1)"
                    >重新解析</el-button
                    > -->
                    <!--                    <el-button style="margin: 5px 0 5px 10px" type="danger" size="mini"-->
                    <!--                               @click="delete_records(scope.row)">删除-->
                    <!--                    </el-button>-->
                </template>
            </el-table-column>
        </el-table>
        <el-row type="flex" justify="end">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-size="query.limit"
                :page-sizes="[20, 50, 100]"
                :total="query.total"
                background
                style="float: right;margin-top: 10px; padding-bottom: 30px"
                layout="total, sizes, prev, pager, next"
            >
            </el-pagination>
        </el-row>
        <el-dialog style="padding: 0 20px 20px 20px !important;" width="30%" center title="错误信息" v-if="errorInfoShow"
                   :visible.sync="errorInfoShow" append-to-body>
            <span style="color: red">错误内容：</span>
            <span>{{errorMsg}}</span>
            <span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="errorInfoShow = false">关 闭</el-button>
			</span>
        </el-dialog>
    </el-dialog>
</template>

<script>
    import * as api from '@/api/Product/Product'
    import {downloadFileUrl, binary_download} from '../../utils/method'

    export default {
        name: 'sbvParseList',
        components: {},
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            formData: {
                type: Object,
                default: ''
            },
            title: {
                type: String,
                default: ''
            },
            type: {
                type: String,
                default: ''
            },
        },
        data() {
            return {
                loading: false,
                errorInfoShow: false,
                errorMsg: '',
                currentId: '',
                ctrl: {
                    addRecordDialogVisible: false
                },
                list: [],
                query: {
                    page: 1,
                    limit: 20,
                    total: 0,
                    type: 'SB'
                },
                rules: {
                    asin: [
                        {
                            required: true,
                            message: '请输入ASIN',
                            trigger: 'blur'
                        }
                    ],
                    state: [
                        {
                            required: true,
                            message: '请输入国家',
                            trigger: 'blur'
                        }
                    ],
                    ad_portfolio_name: [
                        {
                            required: true,
                            message: '请输入广告组合名称',
                            trigger: 'blur'
                        }
                    ],
                    type: [
                        {
                            required: true,
                            message: '请选择广告组类型',
                            trigger: 'blur'
                        }
                    ]
                }
            }
        },
        mounted() {
            const keys = Object.keys(this.formData)
            for (const key of keys) {
                this.$set(this.query, key, this.formData[key])
            }
            this.$nextTick(() => {
                this.getList()
            })
        },
        methods: {
            //查询
            onSubmit() {
                this.query.page = 1
                this.getList()
            },
            onReset() {
                this.$set(this, 'query', {type: 'SB'})
                this.query.page = 1
                this.query.limit = 20
                this.getList()
            },
            searchForm() {
                this.getList()
            },
            showErrorInfo(info) {
                this.errorInfoShow = true
                this.errorMsg = info.parsing_err_msg
            },
            async startDecode(row, force = 0) {
                if (force) {
                    await this.$confirm('是否重新运行解析任务', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    })
                }
                let list = JSON.parse(JSON.stringify(this.list))
                api.reduce_bid_parsing_file({
                    id: row.id,
                    force
                }).then(() => {
                    const index = list.findIndex(item => item.id === row.id)
                    list[index].status = 1
                    this.list = list
                })
            },
            getList() {
                this.loading = true
                this.query.type = this.type
                api.sb_sbv_portfolio_parse_list(this.query).then(res => {
                    if (res.code === 0) {
                        this.list = res.data.list
                        this.query.total = res.data.total;
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.message
                        })
                    }
                }).finally(() => {
                    this.loading = false
                })
            },
            // 关闭弹窗
            handleClose(isshow = false) {
                this.$emit('close-callback', isshow)
            },
            addRecords() {
                this.ctrl.addRecordDialogVisible = true
            },
            delete_records(data) {
                this.$confirm('确认删除该记录吗?', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.out_three_page_delete({id: data.id}).then(() => {
                        this.$message.success('删除成功')
                        this.getList()
                    })
                })
            },
            closeCllback() {
                this.ctrl.addRecordDialogVisible = false
            },
            //分页
            handleCurrentChange(val) {
                this.query.page = val
                this.getList()
            },
            handleSizeChange(val) {
                this.query.limit = val
                this.getList()
            },
            downLoad(data) {
                if (!data.parsing_path) {
                    return this.$message({type: 'error', message: '无法下载！'})
                }
                downloadFileUrl(data.parsing_path)
            }
        }
    }
</script>

<style type="text/scss" lang="scss" scoped>
    /deep/ .el-card__header {
        padding: 14px 20px !important;
    }

    /deep/ .el-tabs__content {
        overflow: visible !important;
    }

    /deep/ .el-card {
        overflow: visible !important;
    }

    /deep/ .el-dialog__body {
        padding: 0px 20px 20px 20px !important;
    }

    .mini_div .el-button--mini {
        padding: 5px 5px !important;
    }

    /deep/ .el-table__expanded-cell {
        padding: 0 0 !important;
    }
</style>
